import React, { Component } from 'react';
import { Link } from 'react-router-dom';
export function SimpleBrandManual() {
  return <div className="w-full min-h-screen bg-white pt-24 pb-20" data-id="element-1115">
      <div className="container mx-auto px-6" data-id="element-1116">
        <div className="max-w-4xl mx-auto" data-id="element-1117">
          {/* Header */}
          <div className="mb-16" data-id="element-1118">
            <Link to="/" className="text-black hover:text-gray-700 transition-colors inline-block mb-8" data-id="element-1119">
              ← Volver
            </Link>
            <h1 className="text-5xl font-normal text-black mb-4" data-id="element-1120">
              Manual de Marca
            </h1>
            <p className="text-xl text-gray-700" data-id="element-1121">
              Guía rápida de estilos para explorandoconfran
            </p>
          </div>

          {/* Colors */}
          <section className="mb-16" data-id="element-1122">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1123">Colores</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6" data-id="element-1124">
              <div data-id="element-1125">
                <div className="h-24 bg-black rounded mb-2" data-id="element-1126"></div>
                <p className="text-sm font-medium" data-id="element-1127">Negro #000000</p>
                <p className="text-xs text-gray-600" data-id="element-1128">Texto, botones, énfasis</p>
              </div>
              <div data-id="element-1129">
                <div className="h-24 bg-white border-2 border-gray-200 rounded mb-2" data-id="element-1130"></div>
                <p className="text-sm font-medium" data-id="element-1131">Blanco #FFFFFF</p>
                <p className="text-xs text-gray-600" data-id="element-1132">Fondo, tarjetas</p>
              </div>
              <div data-id="element-1133">
                <div className="h-24 bg-gray-50 rounded mb-2" data-id="element-1134"></div>
                <p className="text-sm font-medium" data-id="element-1135">Gray-50 #F9FAFB</p>
                <p className="text-xs text-gray-600" data-id="element-1136">Fondos alternos</p>
              </div>
              <div data-id="element-1137">
                <div className="h-24 bg-gray-200 rounded mb-2" data-id="element-1138"></div>
                <p className="text-sm font-medium" data-id="element-1139">Gray-200 #E5E7EB</p>
                <p className="text-xs text-gray-600" data-id="element-1140">Bordes, divisores</p>
              </div>
              <div data-id="element-1141">
                <div className="h-24 bg-gray-600 rounded mb-2" data-id="element-1142"></div>
                <p className="text-sm font-medium text-white" data-id="element-1143">
                  Gray-600 #4B5563
                </p>
                <p className="text-xs text-gray-400" data-id="element-1144">Texto secundario</p>
              </div>
              <div data-id="element-1145">
                <div className="h-24 bg-gray-700 rounded mb-2" data-id="element-1146"></div>
                <p className="text-sm font-medium text-white" data-id="element-1147">
                  Gray-700 #374151
                </p>
                <p className="text-xs text-gray-400" data-id="element-1148">Texto párrafos</p>
              </div>
            </div>
          </section>

          {/* Typography */}
          <section className="mb-16" data-id="element-1149">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1150">Tipografía</h2>
            <div className="space-y-6 bg-gray-50 p-8 rounded-lg" data-id="element-1151">
              <div data-id="element-1152">
                <h1 className="text-5xl font-normal text-black mb-2" data-id="element-1153">
                  explorandoconfran
                </h1>
                <code className="text-xs text-gray-600" data-id="element-1154">
                  text-5xl font-normal
                </code>
              </div>
              <div data-id="element-1155">
                <h2 className="text-4xl font-normal text-black mb-2" data-id="element-1156">
                  Audiencia y Alcance
                </h2>
                <code className="text-xs text-gray-600" data-id="element-1157">
                  text-4xl font-normal
                </code>
              </div>
              <div data-id="element-1158">
                <h3 className="text-3xl font-normal text-black mb-2" data-id="element-1159">
                  Lo que más significa
                </h3>
                <code className="text-xs text-gray-600" data-id="element-1160">
                  text-3xl font-normal
                </code>
              </div>
              <div data-id="element-1161">
                <h4 className="text-2xl font-normal text-black mb-2" data-id="element-1162">
                  Media Kit
                </h4>
                <code className="text-xs text-gray-600" data-id="element-1163">
                  text-2xl font-normal
                </code>
              </div>
              <div data-id="element-1164">
                <h5 className="text-xl font-normal text-black mb-2" data-id="element-1165">
                  Contenido Auténtico
                </h5>
                <code className="text-xs text-gray-600" data-id="element-1166">
                  text-xl font-normal
                </code>
              </div>
              <div data-id="element-1167">
                <p className="text-lg text-gray-700 leading-relaxed mb-2" data-id="element-1168">
                  Párrafo grande: Más de 17 mil almas curiosas me acompañan en
                  cada camino.
                </p>
                <code className="text-xs text-gray-600" data-id="element-1169">
                  text-lg text-gray-700 leading-relaxed
                </code>
              </div>
              <div data-id="element-1170">
                <p className="text-base text-gray-700 leading-relaxed mb-2" data-id="element-1171">
                  Párrafo normal: Juntos recorremos montañas, ríos y senderos
                  que cuentan historias.
                </p>
                <code className="text-xs text-gray-600" data-id="element-1172">
                  text-base text-gray-700 leading-relaxed
                </code>
              </div>
              <div data-id="element-1173">
                <p className="text-sm text-gray-600 mb-2" data-id="element-1174">
                  Texto pequeño: Visualizaciones (últimos 60 días)
                </p>
                <code className="text-xs text-gray-600" data-id="element-1175">
                  text-sm text-gray-600
                </code>
              </div>
            </div>
          </section>

          {/* Buttons */}
          <section className="mb-16" data-id="element-1176">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1177">Botones</h2>
            <div className="space-y-6" data-id="element-1178">
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1179">
                <button className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors mb-3" data-id="element-1180">
                  Colaboremos
                </button>
                <code className="block text-xs text-gray-600" data-id="element-1181">
                  bg-black text-white px-8 py-3 text-sm uppercase
                  hover:bg-gray-800 transition-colors
                </code>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1182">
                <button className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors rounded-full mb-3" data-id="element-1183">
                  Hablemos
                </button>
                <code className="block text-xs text-gray-600" data-id="element-1184">
                  bg-black text-white px-8 py-3 text-sm uppercase
                  hover:bg-gray-800 transition-colors rounded-full
                </code>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1185">
                <button className="border border-black px-8 py-3 text-sm uppercase hover:bg-gray-100 transition-colors mb-3" data-id="element-1186">
                  Ver Más
                </button>
                <code className="block text-xs text-gray-600" data-id="element-1187">
                  border border-black px-8 py-3 text-sm uppercase
                  hover:bg-gray-100 transition-colors
                </code>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1188">
                <a href="#" className="text-black hover:text-gray-700 transition-colors inline-block mb-3" data-id="element-1189">
                  ← Volver
                </a>
                <code className="block text-xs text-gray-600" data-id="element-1190">
                  text-black hover:text-gray-700 transition-colors
                </code>
              </div>
            </div>
          </section>

          {/* Cards */}
          <section className="mb-16" data-id="element-1191">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1192">Tarjetas</h2>
            <div className="space-y-8" data-id="element-1193">
              <div data-id="element-1194">
                <div className="bg-white p-8 rounded-lg shadow-sm mb-3" data-id="element-1195">
                  <h3 className="text-xl font-normal text-black mb-4" data-id="element-1196">
                    Tarjeta Básica
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed" data-id="element-1197">
                    Contenido de ejemplo para mostrar el estilo de tarjeta.
                  </p>
                </div>
                <code className="text-xs text-gray-600" data-id="element-1198">
                  bg-white p-8 rounded-lg shadow-sm
                </code>
              </div>

              <div data-id="element-1199">
                <div className="bg-gray-50 p-8 rounded-lg mb-3" data-id="element-1200">
                  <h3 className="text-xl font-normal text-black mb-4" data-id="element-1201">
                    Tarjeta Gris
                  </h3>
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-1202">
                    Usada para estadísticas y datos destacados.
                  </p>
                </div>
                <code className="text-xs text-gray-600" data-id="element-1203">
                  bg-gray-50 p-8 rounded-lg
                </code>
              </div>

              <div data-id="element-1204">
                <div className="border-t-2 border-black pt-8 bg-white p-8 rounded-lg shadow-sm mb-3" data-id="element-1205">
                  <h3 className="text-xl font-medium text-black mb-3" data-id="element-1206">
                    Tarjeta con Borde
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed" data-id="element-1207">
                    Para planes de precios y servicios destacados.
                  </p>
                </div>
                <code className="text-xs text-gray-600" data-id="element-1208">
                  border-t-2 border-black pt-8 bg-white p-8 rounded-lg shadow-sm
                </code>
              </div>
            </div>
          </section>

          {/* Spacing */}
          <section className="mb-16" data-id="element-1209">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1210">Espaciado</h2>
            <div className="bg-gray-50 p-8 rounded-lg space-y-6" data-id="element-1211">
              <div className="flex items-center gap-4" data-id="element-1212">
                <div className="h-20 w-4 bg-black rounded" data-id="element-1213"></div>
                <div data-id="element-1214">
                  <p className="text-sm font-medium" data-id="element-1215">py-20 (80px)</p>
                  <p className="text-xs text-gray-600" data-id="element-1216">
                    Márgenes verticales de sección
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1217">
                <div className="h-12 w-4 bg-black rounded" data-id="element-1218"></div>
                <div data-id="element-1219">
                  <p className="text-sm font-medium" data-id="element-1220">py-12 (48px)</p>
                  <p className="text-xs text-gray-600" data-id="element-1221">
                    Espaciado entre subsecciones
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1222">
                <div className="h-8 w-4 bg-black rounded" data-id="element-1223"></div>
                <div data-id="element-1224">
                  <p className="text-sm font-medium" data-id="element-1225">py-8 (32px)</p>
                  <p className="text-xs text-gray-600" data-id="element-1226">
                    Padding de tarjetas y contenedores
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1227">
                <div className="h-6 w-4 bg-black rounded" data-id="element-1228"></div>
                <div data-id="element-1229">
                  <p className="text-sm font-medium" data-id="element-1230">py-6 (24px)</p>
                  <p className="text-xs text-gray-600" data-id="element-1231">
                    Espaciado entre elementos relacionados
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-1232">
                <div className="h-4 w-4 bg-black rounded" data-id="element-1233"></div>
                <div data-id="element-1234">
                  <p className="text-sm font-medium" data-id="element-1235">py-4 (16px)</p>
                  <p className="text-xs text-gray-600" data-id="element-1236">
                    Espaciado interno de componentes
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Layout */}
          <section className="mb-16" data-id="element-1237">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1238">Layout</h2>
            <div className="space-y-8" data-id="element-1239">
              <div data-id="element-1240">
                <p className="text-base font-medium text-black mb-4" data-id="element-1241">
                  Contenedor Principal
                </p>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1242">
                  <code className="text-sm text-gray-700" data-id="element-1243">
                    container mx-auto px-6
                  </code>
                  <p className="text-xs text-gray-600 mt-2" data-id="element-1244">
                    Ancho máximo con márgenes automáticos y padding horizontal
                  </p>
                </div>
              </div>

              <div data-id="element-1245">
                <p className="text-base font-medium text-black mb-4" data-id="element-1246">
                  Grid 2 Columnas
                </p>
                <div className="bg-gray-50 p-6 rounded-lg mb-3" data-id="element-1247">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1248">
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1249">
                      <span className="text-xs text-gray-600" data-id="element-1250">Col 1</span>
                    </div>
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1251">
                      <span className="text-xs text-gray-600" data-id="element-1252">Col 2</span>
                    </div>
                  </div>
                </div>
                <code className="text-xs text-gray-600" data-id="element-1253">
                  grid grid-cols-1 md:grid-cols-2 gap-8
                </code>
              </div>

              <div data-id="element-1254">
                <p className="text-base font-medium text-black mb-4" data-id="element-1255">
                  Grid 3 Columnas
                </p>
                <div className="bg-gray-50 p-6 rounded-lg mb-3" data-id="element-1256">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1257">
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1258">
                      <span className="text-xs text-gray-600" data-id="element-1259">Col 1</span>
                    </div>
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1260">
                      <span className="text-xs text-gray-600" data-id="element-1261">Col 2</span>
                    </div>
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1262">
                      <span className="text-xs text-gray-600" data-id="element-1263">Col 3</span>
                    </div>
                  </div>
                </div>
                <code className="text-xs text-gray-600" data-id="element-1264">
                  grid grid-cols-1 md:grid-cols-3 gap-8
                </code>
              </div>

              <div data-id="element-1265">
                <p className="text-base font-medium text-black mb-4" data-id="element-1266">
                  Grid 4 Columnas
                </p>
                <div className="bg-gray-50 p-6 rounded-lg mb-3" data-id="element-1267">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1268">
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1269">
                      <span className="text-xs text-gray-600" data-id="element-1270">1</span>
                    </div>
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1271">
                      <span className="text-xs text-gray-600" data-id="element-1272">2</span>
                    </div>
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1273">
                      <span className="text-xs text-gray-600" data-id="element-1274">3</span>
                    </div>
                    <div className="h-20 bg-white border-2 border-dashed border-gray-300 rounded flex items-center justify-center" data-id="element-1275">
                      <span className="text-xs text-gray-600" data-id="element-1276">4</span>
                    </div>
                  </div>
                </div>
                <code className="text-xs text-gray-600" data-id="element-1277">
                  grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8
                </code>
              </div>
            </div>
          </section>

          {/* Forms */}
          <section className="mb-16" data-id="element-1278">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1279">
              Formularios
            </h2>
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1280">
              <div className="max-w-md space-y-6" data-id="element-1281">
                <div data-id="element-1282">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1283">
                    Input de Texto
                  </label>
                  <input type="text" className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black transition-all" placeholder="Placeholder" data-id="element-1284" />
                  <code className="block text-xs text-gray-600 mt-2" data-id="element-1285">
                    w-full px-4 py-3 border border-gray-300 rounded-md
                    focus:ring-2 focus:ring-black focus:border-black
                  </code>
                </div>
                <div data-id="element-1286">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1287">
                    Textarea
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-black focus:border-black transition-all resize-none" placeholder="Mensaje" data-id="element-1288"></textarea>
                  <code className="block text-xs text-gray-600 mt-2" data-id="element-1289">
                    w-full px-4 py-3 border border-gray-300 rounded-md
                    focus:ring-2 focus:ring-black focus:border-black resize-none
                  </code>
                </div>
              </div>
            </div>
          </section>

          {/* Images */}
          <section className="mb-16" data-id="element-1290">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1291">Imágenes</h2>
            <div className="bg-gray-50 p-8 rounded-lg space-y-6" data-id="element-1292">
              <div data-id="element-1293">
                <p className="text-base font-medium text-black mb-4" data-id="element-1294">
                  Esquinas Redondeadas
                </p>
                <div className="w-48 h-32 bg-gray-300 rounded-lg mb-2" data-id="element-1295"></div>
                <code className="text-xs text-gray-600" data-id="element-1296">rounded-lg</code>
              </div>
              <div data-id="element-1297">
                <p className="text-base font-medium text-black mb-4" data-id="element-1298">
                  Object Cover
                </p>
                <code className="text-xs text-gray-600 block bg-white p-3 rounded" data-id="element-1299">
                  object-cover (mantiene proporciones sin distorsión)
                </code>
              </div>
              <div data-id="element-1300">
                <p className="text-base font-medium text-black mb-4" data-id="element-1301">
                  Aspect Ratios Comunes
                </p>
                <div className="space-y-3" data-id="element-1302">
                  <div data-id="element-1303">
                    <div className="w-full aspect-video bg-gray-300 rounded-lg mb-1" data-id="element-1304"></div>
                    <code className="text-xs text-gray-600" data-id="element-1305">
                      aspect-video (16:9)
                    </code>
                  </div>
                  <div data-id="element-1306">
                    <div className="w-32 aspect-[9/16] bg-gray-300 rounded-lg mb-1" data-id="element-1307"></div>
                    <code className="text-xs text-gray-600" data-id="element-1308">
                      aspect-[9/16] (vertical)
                    </code>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Icons */}
          <section className="mb-16" data-id="element-1309">
            <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1310">Iconos</h2>
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1311">
              <p className="text-base text-gray-700 mb-6" data-id="element-1312">
                <strong data-id="element-1313">Librería:</strong> Lucide React
              </p>
              <div className="bg-white p-4 rounded mb-6" data-id="element-1314">
                <code className="text-xs text-gray-700" data-id="element-1315">
                  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
                </code>
              </div>
              <div className="flex gap-8 items-center" data-id="element-1316">
                <div className="flex flex-col items-center" data-id="element-1317">
                  <svg className="h-6 w-6 mb-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1318">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-1319"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-1320"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-1321"></line>
                  </svg>
                  <span className="text-xs text-gray-600" data-id="element-1322">Instagram</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-1323">
                  <svg className="h-6 w-6 mb-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1324">
                    <line x1="3" y1="12" x2="21" y2="12" data-id="element-1325"></line>
                    <line x1="3" y1="6" x2="21" y2="6" data-id="element-1326"></line>
                    <line x1="3" y1="18" x2="21" y2="18" data-id="element-1327"></line>
                  </svg>
                  <span className="text-xs text-gray-600" data-id="element-1328">Menu</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-1329">
                  <svg className="h-6 w-6 mb-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1330">
                    <path d="M18 6L6 18M6 6l12 12" data-id="element-1331" />
                  </svg>
                  <span className="text-xs text-gray-600" data-id="element-1332">Close</span>
                </div>
              </div>
            </div>
          </section>

          {/* Quick Reference */}
          <section className="bg-black text-white p-12 rounded-lg" data-id="element-1333">
            <h2 className="text-3xl font-normal mb-8" data-id="element-1334">Referencia Rápida</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-sm" data-id="element-1335">
              <div data-id="element-1336">
                <h3 className="text-lg font-medium mb-4" data-id="element-1337">
                  Colores Principales
                </h3>
                <ul className="space-y-2 text-gray-300" data-id="element-1338">
                  <li data-id="element-1339">• Negro: #000000</li>
                  <li data-id="element-1340">• Blanco: #FFFFFF</li>
                  <li data-id="element-1341">• Gray-50: #F9FAFB</li>
                  <li data-id="element-1342">• Gray-700: #374151</li>
                </ul>
              </div>
              <div data-id="element-1343">
                <h3 className="text-lg font-medium mb-4" data-id="element-1344">Espaciado</h3>
                <ul className="space-y-2 text-gray-300" data-id="element-1345">
                  <li data-id="element-1346">• Secciones: py-20</li>
                  <li data-id="element-1347">• Tarjetas: p-8</li>
                  <li data-id="element-1348">• Gaps: gap-8</li>
                  <li data-id="element-1349">• Contenedor: px-6</li>
                </ul>
              </div>
              <div data-id="element-1350">
                <h3 className="text-lg font-medium mb-4" data-id="element-1351">Tipografía</h3>
                <ul className="space-y-2 text-gray-300" data-id="element-1352">
                  <li data-id="element-1353">• H1: text-5xl font-normal</li>
                  <li data-id="element-1354">• H2: text-4xl font-normal</li>
                  <li data-id="element-1355">• Párrafo: text-base leading-relaxed</li>
                  <li data-id="element-1356">• Pequeño: text-sm</li>
                </ul>
              </div>
              <div data-id="element-1357">
                <h3 className="text-lg font-medium mb-4" data-id="element-1358">Componentes</h3>
                <ul className="space-y-2 text-gray-300" data-id="element-1359">
                  <li data-id="element-1360">• Botón: px-8 py-3 text-sm uppercase</li>
                  <li data-id="element-1361">• Tarjeta: p-8 rounded-lg shadow-sm</li>
                  <li data-id="element-1362">• Input: px-4 py-3 rounded-md</li>
                  <li data-id="element-1363">• Imagen: rounded-lg object-cover</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>;
}